import { render, staticRenderFns } from "./main.vue?vue&type=template&id=1436fecb&"
import script from "./main.vue?vue&type=script&lang=js&"
export * from "./main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/data/websites/erp-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1436fecb')) {
      api.createRecord('1436fecb', component.options)
    } else {
      api.reload('1436fecb', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=1436fecb&", function () {
      api.rerender('1436fecb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/uploadPic/main.vue"
export default component.exports